var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebariconclose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 76,
    viewBox: "0 0 28 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 68.6579V7.34206C0 4.17422 3.50727 2.26343 6.16896 3.98117L26.169 16.8883C27.3104 17.6249 28 18.8906 28 20.2492V55.7508C28 57.1094 27.3104 58.3751 26.169 59.1117L6.16897 72.0188C3.50727 73.7366 0 71.8258 0 68.6579Z",
    fill: "url(#paint0_linear_25_621)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 45.5L9.5 38L17 30.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_621",
    x1: 3.5,
    y1: 5.5,
    x2: 14,
    y2: 66.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5965C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#303B97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebariconclose);
export default __webpack_public_path__ + "static/media/sidebariconclose.571d8e5b6fce8ac5e7cc80e03525ec69.svg";
export { ForwardRef as ReactComponent };